import { IconUserImages, IconUserChristmasImages } from "../../../elements/Icon";
import { checkChristmas } from "../../../../hooks/useCheckChristmas";
import { useDispatch } from "react-redux";
import { updateSelectedProfile } from "../../../../redux/features/userSlice";
import { getProfileGameThunk, getTotalScoreThunk } from "../../../../redux/features/gamesSlice";
import { useParams } from "react-router-dom";
import { useRef } from "react";

export const AddProfile = ({
    handleState,
    selectedAvatars,
    subscription,
    handleSubscription,
    selectedProfile
}) => {
    const dispatch = useDispatch();
    const { name } = useParams();

    const sliderRef = useRef(null);

    const isDown = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    const handleMouseDown = (e) => {
        if (window.innerWidth >= 640) return;

        isDown.current = true;
        startX.current = e.pageX - sliderRef.current.offsetLeft;
        scrollLeft.current = sliderRef.current.scrollLeft;
    };

    const handleMouseLeave = () => {
        isDown.current = false;
    };

    const handleMouseUp = () => {
        isDown.current = false;
    };

    const handleMouseMove = (e) => {
        if (!isDown.current) return;

        e.preventDefault();

        const x = e.pageX - sliderRef.current.offsetLeft;
        const walk = (x - startX.current) * 1.5;

        sliderRef.current.scrollLeft = scrollLeft.current - walk;
    };

    const prev = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollLeft += 154;
        }
    };

    const next = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollLeft -= 154;
        }
    };

    return (
        <div className="flex items-center">
            <img
                src={"/backGrounds/profile/arrow.svg"}
                className={`block sm:hidden
            w-[12px] h-[20px]
            md:w-[15px] md:h-[25px]
            lg:w-[19px] lg:h-[31px]
            cursor-pointer
            ${selectedAvatars.length < 2 ? "opacity-0 pointer-events-none" : ""}
        `}
                onClick={(e) => {
                    e.stopPropagation();
                    next();
                }}
            />
            <div
                ref={selectedAvatars.length >= 2 ? sliderRef : null}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
                className={`
                w-[320px]  sm:w-[352px]
                h-[150px] sm:h-[79.53px]
                md:w-[402px] md:h-[105px]
                lg:h-[134px] lg:w-[546px]
                xl:w-[749px] xl:h-[183px]
                flex
                ${selectedAvatars.length >= 2
                        ? "overflow-x-scroll scrollbar-hide sm:overflow-visible gap-[40px] px-[20px] sm:px-0 sm:gap-0 sm:justify-around"
                        : "justify-center"
                    }
            `}
            >
                {selectedAvatars.map((item, i) => {
                    return (
                        <div
                            key={i}
                            onClick={() => {
                                if (item && subscription) {
                                    dispatch(
                                        getProfileGameThunk({
                                            userId: localStorage.getItem("user"),
                                            profileId: item._id,
                                            collection: name
                                        })
                                    );

                                    dispatch(
                                        getTotalScoreThunk({
                                            userId: localStorage.getItem("user"),
                                            profileId: item._id,
                                        })
                                    );

                                    dispatch(updateSelectedProfile(item));
                                }
                            }}
                            className={`
                            ${selectedProfile?.avatar === item?.avatar
                                    ? "border-[#885AC0] bg-[#CCAED1]"
                                    : "border-[#E3D8D8] bg-[#D7CCD9]"
                                }
                            min-w-[124px] sm:min-w-[79.53px]
                            w-[124px] sm:w-[79.53px]
                            h-[124px] sm:h-full
                            md:w-[105px] md:h-[105px]
                            lg:w-[134px] lg:h-[134px]
                            xl:w-[183px] xl:h-[183px]
                            relative border-[3px] lg:border-[4px]
                            rounded-full flex justify-end items-end
                        `}
                        >
                            <div
                                onClick={(e) => {
                                    e.stopPropagation();

                                    if (subscription || (!subscription && i === 0)) {
                                        handleState(i);
                                    } else {
                                        handleSubscription();
                                    }
                                }}
                                className={`
                                z-[10]
                                w-[30px] h-[30px]
                                sm:w-[22px] sm:h-[22px]
                                md:w-[29px] md:h-[29px]
                                lg:w-[35px] lg:h-[35px]
                                xl:w-[48px] xl:h-[48px]
                                ${item
                                        ? "bg-[url('/backGrounds/profile/edit.svg')]"
                                        : "bg-[url('/backGrounds/profile/+.svg')]"
                                    }
                                bg-cover bg-no-repeat cursor-pointer
                            `}
                            />

                            {!subscription && selectedAvatars.length > 1 && (
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleSubscription();
                                    }}
                                    className={`
                                    absolute top-0 z-[10]
                                    w-[30px] h-[30px]
                                    sm:w-[25px] sm:h-[25px]
                                    md:w-[33px] md:h-[33px]
                                    lg:w-[40px] lg:h-[40px]
                                    xl:w-[52px] xl:h-[52px]
                                    ${item
                                            ? ""
                                            : "bg-[url('/backGrounds/profile/lock.svg')]"
                                        }
                                    bg-cover bg-no-repeat cursor-pointer
                                `}
                                />
                            )}

                            <div className="absolute w-full h-full overflow-hidden top-0 z-0 rounded-full">
                                {item && checkChristmas() && (
                                    <IconUserChristmasImages user={item.avatar} />
                                )}

                                {item && !checkChristmas() && (
                                    <IconUserImages user={item.avatar} />
                                )}
                            </div>

                            <span className="absolute -bottom-6 lg:-bottom-8 left-1/2 -translate-x-1/2 truncate text-[12px] md:text-[14px] lg:text-[16px] font-bold whitespace-nowrap text-[#7743BA]">
                                {item?.nickName}
                            </span>
                        </div>
                    );
                })}
            </div>
            <img
                src={"/backGrounds/profile/arrow.svg"}
                className={`block sm:hidden
            w-[12px] h-[20px]
            md:w-[15px] md:h-[25px]
            lg:w-[19px] lg:h-[31px]
            rotate-180 cursor-pointer
            ${selectedAvatars.length < 2 ? "opacity-0 pointer-events-none" : ""}
        `}
                onClick={(e) => {
                    e.stopPropagation();
                    prev();
                }}
            />
        </div>
    );
};